/**
 * Orion Analytics
 * Financial Intelligence Platform
 *
 * Copyright (c) 2026 Santosh Bag / Orion Analytics Ltd.
 * All rights reserved.
 *
 * Software Development by Cosmo Codeworks Ltd
 *
 * Unauthorized copying, modification, distribution,
 * or commercial use is prohibited.
 */

// src/components/software/SoftwareProducts.jsx

import React, {useState} from "react";


import {
  Smartphone,
  Monitor,
  Globe,
  ArrowRight,
} from "lucide-react";

import OrionEdgeModal from "./OrionEdgeModal";

// const products = [
//   {
//     name: "Orion Edge",
//     status: "LIVE",
//     icon: Smartphone,
//
//     description:
//       "Mobile-first financial toolkit with trading, investing and risk management calculators.",
//
//     href: "/software/orion-edge/",
//
//     badgeColor:
//       "bg-green-100 text-green-700",
//
//     iconBg:
//       "bg-green-100 text-green-700",
//   },
//
//   {
//     name: "Orion Mobile",
//     status: "COMING SOON",
//     icon: Smartphone,
//
//     description:
//       "The complete Orion Analytics experience optimized for mobile devices.",
//
//     href: "/software/orion-mobile/",
//
//     badgeColor:
//       "bg-amber-100 text-amber-700",
//
//     iconBg:
//       "bg-amber-100 text-amber-700",
//   },
//
//   {
//     name: "Orion Analytics",
//     status: "LIVE",
//     icon: Globe,
//
//     description:
//       "Advanced analytics, screening, market intelligence and research platform.",
//
//     href: "/",
//
//     badgeColor:
//       "bg-blue-100 text-blue-700",
//
//     iconBg:
//       "bg-blue-100 text-blue-700",
//   },
// ];

const products = [
  {
    name: "Orion Edge",
    status: "LIVE",
    icon: Smartphone,

    description:
      "Mobile-first financial toolkit with trading, investing and risk management calculators.",

    action: "modal",

    badgeColor: "bg-green-100 text-green-700",
    iconBg: "bg-green-100 text-green-700",
  },

  {
    name: "Orion Mobile",
    status: "COMING SOON",
    icon: Smartphone,

    description:
      "The complete Orion Analytics experience optimized for mobile devices.",

    action: "comingsoon",

    badgeColor: "bg-amber-100 text-amber-700",
    iconBg: "bg-amber-100 text-amber-700",
  },

  {
    name: "Orion Analytics",
    status: "LIVE",
    icon: Globe,

    description:
      "Advanced analytics, screening, market intelligence and research platform.",

    action: "link",
    href: "/",

    badgeColor: "bg-blue-100 text-blue-700",
    iconBg: "bg-blue-100 text-blue-700",
  },
];

const SoftwareProducts = () => {

  const [showEdgeModal, setShowEdgeModal] =
  useState(false);

  const handleProductClick = (product) => {

    if (product.action === "modal") {
      setShowEdgeModal(true);
      return;
    }

    if (product.action === "link") {
      window.location.href = product.href;
      return;
    }

    if (product.action === "comingsoon") {
      return;
    }
  };

  return (

    <section
      className="
        py-24
        px-6
        lg:px-10
        bg-white
      "
    >

      <div className="max-w-7xl mx-auto">

        {/* SECTION HEADER */}

        <div className="mb-14">

          <div
            className="
              text-sm
              uppercase
              tracking-[0.3em]
              text-blue-700
              font-bold
              mb-4
            "
          >
            Orion Ecosystem
          </div>

          <h2
            className="
              text-4xl
              lg:text-5xl
              font-black
              mb-4
            "
          >
            Software Products
          </h2>

          <p
            className="
              text-lg
              text-gray-600
              max-w-3xl
            "
          >
            Discover the growing Orion
            ecosystem spanning web,
            mobile and future intelligence
            platforms.
          </p>

        </div>

        {/* PRODUCT GRID */}

        <div
          className="
            grid
            lg:grid-cols-3
            gap-8
          "
        >

          {products.map((product) => {

            const Icon = product.icon;

            return (

              // <a
              //   key={product.name}
              //   href={product.href}
              //   className="
              //     group
              //     block
              //   "
              // >
              <div
                key={product.name}
                onClick={() =>
                  handleProductClick(product)
                }
                className={`
                  group
                  block
                  ${
                    product.action !== "comingsoon"
                      ? "cursor-pointer"
                      : ""
                  }
                `}
              >

                <div
                  className="
                    bg-[#f8fafc]

                    rounded-[32px]

                    border
                    border-gray-100

                    overflow-hidden

                    hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)]
                    hover:-translate-y-2

                    transition-all
                    duration-300

                    h-full
                  "
                >

                  {/* MOCKUP AREA */}

                  <div
                    className="
                      h-[220px]

                      bg-gradient-to-br
                      from-slate-900
                      via-slate-800
                      to-slate-700

                      flex
                      items-center
                      justify-center
                    "
                  >

                    <Monitor
                      size={80}
                      className="
                        text-white/80
                      "
                    />

                  </div>

                  {/* CONTENT */}

                  <div className="p-8">

                    <div
                      className="
                        flex
                        justify-between
                        items-center
                        mb-6
                      "
                    >

                      <div
                        className={`
                          px-3
                          py-1

                          rounded-full

                          text-xs
                          font-bold

                          ${product.badgeColor}
                        `}
                      >
                        {product.status}
                      </div>

                      <div
                        className={`
                          w-12
                          h-12

                          rounded-xl

                          flex
                          items-center
                          justify-center

                          ${product.iconBg}
                        `}
                      >
                        <Icon size={22} />
                      </div>

                    </div>

                    <h3
                      className="
                        text-2xl
                        font-black
                        mb-4
                      "
                    >
                      {product.name}
                    </h3>

                    <p
                      className="
                        text-gray-600
                        leading-relaxed
                        mb-8
                      "
                    >
                      {product.description}
                    </p>

                    <div
                      className="
                        flex
                        items-center
                        gap-2

                        text-blue-700
                        font-bold

                        group-hover:gap-3

                        transition-all
                      "
                    >
                      {
                        product.action === "modal"
                          ? "View Details"
                          : product.action === "comingsoon"
                          ? "Coming Soon"
                          : "Open Platform"
                      }

                      {
                        product.action !== "comingsoon" && (
                          <ArrowRight size={18} />
                        )
                      }
                    </div>

                  </div>

                </div>

              </div>

            );

          })}

        </div>

      </div>
      <OrionEdgeModal
        open={showEdgeModal}
        onClose={() =>
          setShowEdgeModal(false)
        }
      />
    </section>

  );
};

export default SoftwareProducts;